import { Checkbox, Typography } from '@weareopenr/component-library';
import { ReactNode } from 'react';
import classnames from 'classnames/bind';
import styles from './SelectableList.module.scss';

const cx = classnames.bind(styles);

export interface SelectableListOption {
  label: string;
  id: string;
  subtitle?: string;
  rightText?: string;
  chip?: ReactNode;
  disabled?: boolean;
}

interface SelectableListProps {
  options: SelectableListOption[];
  selectedOptions: string[];
  onChange: (selectedOptions: string[]) => void;
  disabled?: boolean;
}

const SelectableList = ({ options, selectedOptions, onChange, disabled }: SelectableListProps) => {
  const toggleItem = (id: string) => {
    if (selectedOptions.includes(id)) {
      onChange(selectedOptions.filter((selectedId) => selectedId !== id));
    } else {
      onChange([...selectedOptions, id]);
    }
  };

  return (
    <div>
      {options.map(({ id, label, subtitle, rightText, chip, disabled: itemDisabled }) => {
        const subtitleTooltip = subtitle ? subtitle.split(', ').join('\r\n') : undefined;

        return (
          <div className={cx('option-container')} key={id}>
            <div className={cx('option-content')}>
              <div className={cx('checkbox-content', { 'checkbox-content-limited': rightText })}>
                <Checkbox
                  className={cx('checkbox')}
                  labelWeight="regular"
                  ariaLabel={label}
                  alignment="center"
                  checked={selectedOptions.includes(id)}
                  onChange={() => toggleItem(id)}
                  disabled={disabled || itemDisabled}
                  data-testid={`${label}-checkbox`}
                >
                  <div className={cx('label-container')}>
                    <Typography size="medium" weight="regular">
                      <span title={label}>{label}</span>
                    </Typography>
                    {subtitle && (
                      <Typography size="xsmall" className={cx('subtitle-text')}>
                        <span title={subtitleTooltip}>{subtitle}</span>
                      </Typography>
                    )}
                  </div>
                </Checkbox>
              </div>
              {rightText && (
                <Typography size="small" className={cx('right-text')}>
                  {rightText}
                </Typography>
              )}
              {chip && <div className={cx('chip')}>{chip}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SelectableList;
